import { AdminStatsDto } from "../../dto/stats/admin-stats.dto";
import { AdminStats, TopAudioBlock, TopSession } from "../../models/stats/admin-stats.model";

export class AdminStatsMapper {
  public static toModel(dto: AdminStatsDto): AdminStats {
    return {
      totalUsers: dto.total_users,
      sessionStats: {
        totalSessions: dto.session_stats.total_sessions,
        completedSessions: dto.session_stats.completed_sessions,
        trialSessions: dto.session_stats.trial_sessions,
      },
      topPlayedSessions: dto.most_played_sessions.map(session => ({
        sessionTemplateId: session.session_template_id,
        title: session.title,
        listenCount: session.listen_count,
      })) as [TopSession],
      topPlayedAudioBlocks: dto.most_played_audio_blocks.map(block => ({
        buildingBlockTemplateId: block.building_block_template_id,
        title: block.title,
        listenCount: block.listen_count,
      })) as [TopAudioBlock],
    }
  }
}